import Rollbar from 'rollbar';
import { isProduction } from '../config';

export default function(error) {
  if (!Rollbar || !isProduction) return;
  Rollbar.error(error);
}



// WEBPACK FOOTER //
// ./src/helpers/ClientLogger.js